//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.SheetMetal.js";
import "../Features/Features.SheetMetal.SheetmetalBaseBuilder.js";
import "../no/ScCollector.js";
import "../no/Expression.js";
import "../no/SelectDisplayableObject.js";
import "../no/Expression.js";
import "../no/ScCollector.js";
import "../no/SelectObject.js";
let d=[[[1,"BendFaces",0,"ScCollector",0],[1,"BendRadius",0,"Expression",0],[1,"BendReliefDepth",0,"Expression",0],[0,"BendReliefType",0,0],[1,"BendReliefWidth",0,"Expression",0],[1,"ReferenceEntity",0,"SelectDisplayableObject",0],[0,"Type",1,0]],[[["bend_relief_type"],"SetBendReliefType",{},1,0]],[]];
SPLM.Features.SheetMetal.ResizeBendRadiusBuilder = class extends SPLM.Features.SheetMetal.SheetmetalBaseBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.SheetMetal.ResizeBendRadiusBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.SheetMetal.ResizeBendRadiusBuilder.Types = Object.freeze({
    "FixedFoldedLength" : "FixedFoldedLength", "FixedUnfoldedLength" : "FixedUnfoldedLength"});

SPLM.Features.SheetMetal.ResizeBendRadiusBuilder.BendReliefTypeOptions = Object.freeze({
    "Square" : "Square", "Round" : "Round", "None" : "None"});

export default SPLM;